import AbstractCommand from "../../../core/application/AbstractCommand";
import CharacterLibrary from "../../characters/model/CharacterLibrary";
import OnboardingModel from "../../onboarding/model/OnboardingModel";
import PersonalReportModel from "../../personal-report/model/PersonalReportModel";
import PlayerModel from "../../player/model/PlayerModel";
import ProgressModel from "../../progress/model/ProgressModel";
import SaveGameEvent from "../event/SaveGameEvent";
import SaveGameModel from "../model/SaveGameModel";
import SaveGameService from "./SaveGameService";

export default class SaveGameCommand extends AbstractCommand {
    /**
     * @constructor
     * @param {soma.EventDispatcher} dispatcher 
     * @param {SaveGameModel} saveGameModel 
     * @param {SaveGameService} saveGameService 
     * @param {ProgressModel} progressModel 
     * @param {PlayerModel} playerModel 
     * @param {OnboardingModel} onboardingModel 
     * @param {PersonalReportModel} personalReportModel 
     * @param {CharacterLibrary} characterLibrary 
     */
    constructor(dispatcher, saveGameModel, saveGameService, progressModel, playerModel, onboardingModel, personalReportModel, characterLibrary) {
        super(dispatcher);

        this._saveGameModel = saveGameModel;
        this._saveGameService = saveGameService;
        this._progressModel = progressModel;
        this._playerModel = playerModel;
        this._onboardingModel = onboardingModel;
        this._personalReportModel = personalReportModel;
        this._characterLibrary = characterLibrary;
    }

    async execute(evt) {
        this._saveGameModel.progressModelData = this._progressModel.toObject();
        this._saveGameModel.playerModelData = this._playerModel.toObject();
        this._saveGameModel.onboardingModelData = this._onboardingModel.toObject();
        this._saveGameModel.personalReportModelData = this._personalReportModel.toObject();
        this._saveGameModel.charactersData = this._characterLibrary.characters.map(character => character.snapshot());

        try {
            await this._saveGameService.save();
        } catch (ex) {
            console.warn(`[SaveGameCommand] Unable to save game.`, ex);
        } finally {
            this._dispatcher.dispatch(SaveGameEvent.GAME_SAVED);
        }
    }
}